import React from 'react';
import { GetStaticProps } from 'next';
import { NewsPageId } from '../../../../../features/app/pages/domain/constants/PageId';
import { getEnrichedPageById } from '../../../../../features/app/pages/domain/use-cases/getEnrichedPageById';
import { getStaticPathsForPagination } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForPagination';
import { IPressReleasesPageData } from '../../../../../features/news/domain/models/IPressReleasesPageData';
import {
	getAllPressReleases,
	getPressReleasesTotalCount,
} from '../../../../../features/news/domain/use-cases/press-releases';
import { defaultLocale } from '../../../../../features/shared/i18n/locale/constants/default';
import { getLocaleFromPath } from '../../../../../features/shared/i18n/locale/getLocaleFromPath';
import { PressReleasePage } from '../../../../../features/news/ui/PressReleasesPage';

const DEFAULT_PAGE_NUMBER = 1;
const ITEMS_PER_PAGE = 12;

const Page = ({ page, pressReleases, pageNumber }: IPressReleasesPageData) => (
	<PressReleasePage
		page={page}
		pressReleases={pressReleases}
		pageNumber={pageNumber}
		itemsPerPage={ITEMS_PER_PAGE}
	/>
);

export const getStaticPaths = async () =>
	getStaticPathsForPagination(getPressReleasesTotalCount, ITEMS_PER_PAGE);

export const getStaticProps: GetStaticProps = async ({ params }) => {
	const locale = getLocaleFromPath(params?.locale ?? '') ?? defaultLocale;
	const paramPageNumber = Number.parseInt(params?.pageNumber as string, 10);
	const pageNumber = paramPageNumber || DEFAULT_PAGE_NUMBER;
	const [page, pressReleases] = await Promise.all([
		getEnrichedPageById(NewsPageId.PressReleases, locale),
		getAllPressReleases(locale),
	]);

	if (!page) {
		return {
			notFound: true,
		};
	}

	return {
		props: {
			page,
			pressReleases,
			pageNumber,
		},
	};
};

export default Page;
